module.exports = __webpack_public_path__ + "static/img/btn_gfcz.27a25f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/btn_gfcz.png
// module id = AQ93
// module chunks = 7